import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';

import moment from "moment";
const SubjectEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const [isBranch, setBranch] = useState(props ? props.branchRec : {});
 
  const checkRequiredFields = () => {
    if (
      isBranch.branch_name &&
      isBranch.branch_name.trim() !== "" &&
      isBranch.branch_head &&
      isBranch.branch_head.trim() !== "" &&
      isBranch.phone &&
      isBranch.phone.trim() !== ""
    ) {
     
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    let result2 = {};

    if (isBranch.id) {
      result2 = await trasportApi.saveBranch(isBranch);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
      }
    } else {
      result2 = await trasportApi.createBranch(isBranch);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handleFinancial  = async (e) => {
    setBranch({ ...isBranch, [e.target.name]: e.target.value });
  };

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Branch
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate validated={validated}
              >
                <Row>
                <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Branch Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="branch_name"
                        placeholder="Enter Branch Name"
                        value={isBranch.branch_name}
                        onChange={handleFinancial }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Branch Head
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="branch_head"
                        placeholder="Enter Branch head"
                        value={isBranch.branch_head}
                        onChange={handleFinancial }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Email
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter Branch Email"
                        value={isBranch.email}
                        onChange={handleFinancial}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Phone
                      </Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="phone"
                        placeholder="Enter Phone"
                        value={isBranch.phone}
                        onChange={handleFinancial }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};
export default SubjectEdit;
